// Dependencies
import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: block;
  width: 100%;
  border-radius: 4px;
  position: relative;
`

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  padding: 12px;
  border: 1px solid #ced0dd;
  border-radius: 8px;
  background-color: #ffffff;
  transition: all 0.3s;

  &:hover {
    border-color: #4d4d63;
  }
`

type InputElementStyleProps = {
  type: string
}

export const InputElement = styled.input<InputElementStyleProps>`
  width: 100%;
  font-family: 'Fira Sans';
  font-size: 1.125rem;
  line-height: 1.27;
  color: #25272d;

  &::placeholder {
    color: #ced0dd;
  }

  ${({ type }) =>
    type === 'number' &&
    css`
      -moz-appearance: textfield;
      appearance: textfield;

      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
      }
    `}
`

export const ErrorMessageWrapper = styled.div`
  padding: 4px 8px;
  border-radius: 4px;
  background-color: #ffd396;

  display: flex;
  align-items: center;
  gap: 12px;

  transform: translateY(-25%);
  position: absolute;
  right: 0;
  top: -8px;
`

export const ErrorMessageLabel = styled.p`
  font-weight: 400;
  font-size: 14px;
  color: #c05214;
`
